import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2.5,
		d: "M5 12h14m0 0-7-7m7 7-7 7"
	})
});
export default SvgArrowRightSmall;
